import { gql } from "@apollo/client";
import {
  DepartmentNoNestingFragment,
  MarkupNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { Department as DepartmentEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import DepartmentModel from "../../data/model/Department";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const departmentsQuery = gql`
${DepartmentNoNestingFragment}
${PaginatedListMetaNoNestingFragment}
${MarkupNoNestingFragment}
query GetDepartments(${listVariables}) {
    departments(${listOptions}) {
        items {
          ...DepartmentNoNesting
          markup {
            ...MarkupNoNesting
          }

        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const departmentDefinition = new EntityResourceDefinition<
  DepartmentEntity,
  DepartmentModel
>({
  entity: "departments",
  query: departmentsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.name = fetchedEntity?.name || "";
    newEntity.description = fetchedEntity.description || null;
    newEntity.markup = fetchedEntity.markup || [];
    newEntity.preferredTaxGroupId = fetchedEntity.preferredTaxGroupId || null;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "departments", departmentsQuery, options);
  },
});
